import React from "react";
import "./Home.css";
import HomeBanner from "./Components/HomeBanner";
import WhyChooseUs from "./Components/WhyChooseUs";
import RegTech from "./Components/Regtech/RegTech";
import OurSolutions from "./Components/OurSolutions/OurSolutions";
import FindOutHelpForm from "./Components/FindOutHelpForm/FindOutHelpForm";
import SlideShow from "./Components/SlideShow/SlideShow";
import ChooseEvoNext from "./Components/ChooseEvoNext/ChooseEvoNext";
import { useScrollContext } from "../../ScrollContext";
import ClientSection from "../ClientSection/ClientSection";
import ClientTestiMonial from "./Components/ClientTestiMonial/ClientTestiMonial";
import NewTestimonual from "./Components/ClientTestiMonial/NewTestimonial/NewTestimonual";
import SubscriptionBanner from "./Components/SubscriptionBanner/SubscriptionBanner";

const Home = () => {
  const { homeFormRef } = useScrollContext();
  return (
    <>
    <SubscriptionBanner />
    <div className="HomePageContainer">
       
      <HomeBanner />
      <SlideShow />
      <ClientSection />
      <WhyChooseUs />
      <OurSolutions />
      <RegTech />
      <NewTestimonual />
      <div ref={homeFormRef}></div>
      <FindOutHelpForm />
      <ChooseEvoNext />
    </div>
    </>
  );
};

export default Home;
